const dockerfile = (lines) => `${lines.join('\n')}\n`;

export const ENVIRONMENT_PRESET_CATALOG = [
  {
    id: 'general-researcher-v1',
    name: 'General Researcher',
    domain: 'general-researcher',
    env_version: 'v1.0.0',
    description: 'Balanced baseline for web research, document parsing, and light analysis.',
    data_modality: ['docs', 'tabular', 'web'],
    tooling: ['requests', 'beautifulsoup4', 'pandas'],
    network_policy: 'restricted-web',
    mode: 'simple',
    source_repo: 'builtin/frontend',
    source_ref: 'v1',
    environment: {
      base_image: 'python:3.11-slim',
      system_packages: ['bash', 'curl', 'jq', 'git', 'poppler-utils', 'tesseract-ocr'],
      python_packages: [
        'pypdf',
        'pdfplumber',
        'python-docx',
        'pandas',
        'requests',
        'beautifulsoup4',
        'lxml',
        'rapidfuzz'
      ],
      resources: { cpus: 2, memory_mb: 4096, storage_mb: 10240, gpus: 0 },
      timeouts: { agent_sec: 1200, verifier_sec: 900, build_sec: 900 },
    },
  },
  {
    id: 'finance-v1',
    name: 'Finance Analyst',
    domain: 'finance',
    env_version: 'v1.0.0',
    description: 'Tabular analytics, stats, and spreadsheet workflows for finance tasks.',
    data_modality: ['tabular', 'spreadsheets'],
    tooling: ['pandas', 'polars', 'statsmodels', 'excel'],
    network_policy: 'restricted-web',
    mode: 'simple',
    source_repo: 'builtin/frontend',
    source_ref: 'v1',
    environment: {
      base_image: 'python:3.11-slim',
      system_packages: ['bash', 'curl', 'jq', 'git'],
      python_packages: [
        'pandas==2.2.3',
        'numpy==2.1.3',
        'scipy==1.14.1',
        'statsmodels==0.14.4',
        'polars==1.12.0',
        'pyarrow==18.0.0',
        'openpyxl==3.1.5',
        'xlsxwriter==3.2.0',
        'pyxlsb==1.0.10',
        'tabulate==0.9.0',
        'matplotlib==3.9.2'
      ],
      resources: { cpus: 2, memory_mb: 4096, storage_mb: 10240, gpus: 0 },
      timeouts: { agent_sec: 1200, verifier_sec: 900, build_sec: 900 },
    },
  },
  {
    id: 'law-v1',
    name: 'Legal Review',
    domain: 'law',
    env_version: 'v1.0.0',
    description: 'OCR, PDF extraction, and legal document conversion workflow starter.',
    data_modality: ['docs', 'pdfs'],
    tooling: ['ocr', 'pdf', 'docx', 'fuzzy-matching'],
    network_policy: 'offline',
    mode: 'dockerfile',
    source_repo: 'builtin/frontend',
    source_ref: 'v1',
    environment: {
      base_image: 'python:3.11-slim',
      system_packages: [
        'bash',
        'curl',
        'jq',
        'git',
        'tesseract-ocr',
        'tesseract-ocr-eng',
        'poppler-utils',
        'libreoffice',
        'pandoc',
        'antiword',
        'unrtf'
      ],
      python_packages: [
        'pypdf==5.1.0',
        'pdfplumber==0.11.4',
        'python-docx==1.1.2',
        'docx2txt==0.8',
        'pytesseract==0.3.13',
        'rapidfuzz==3.10.1',
        'spacy==3.8.2',
        'textstat==0.7.4'
      ],
      dockerfile: dockerfile([
        'FROM python:3.11-slim',
        '',
        'ENV DEBIAN_FRONTEND=noninteractive \\',
        '    PIP_NO_CACHE_DIR=1 \\',
        '    PYTHONUNBUFFERED=1',
        '',
        'WORKDIR /app',
        '',
        'RUN apt-get update && apt-get install -y --no-install-recommends \\',
        '    bash curl jq git \\',
        '    tesseract-ocr tesseract-ocr-eng \\',
        '    poppler-utils \\',
        '    libreoffice \\',
        '    pandoc \\',
        '    antiword unrtf \\',
        '    && rm -rf /var/lib/apt/lists/*',
        '',
        'RUN pip install \\',
        '    pypdf==5.1.0 \\',
        '    pdfplumber==0.11.4 \\',
        '    python-docx==1.1.2 \\',
        '    docx2txt==0.8 \\',
        '    pytesseract==0.3.13 \\',
        '    rapidfuzz==3.10.1 \\',
        '    spacy==3.8.2 \\',
        '    textstat==0.7.4',
        '',
        'CMD ["/bin/bash"]',
      ]),
      resources: { cpus: 2, memory_mb: 4096, storage_mb: 10240, gpus: 0 },
      timeouts: { agent_sec: 1200, verifier_sec: 900, build_sec: 1200 },
    },
  },
  {
    id: 'chemistry-v1',
    name: 'Chemistry',
    domain: 'chemistry',
    env_version: 'v1.0.0',
    description: 'Cheminformatics starter with RDKit/Open Babel and scientific Python stack.',
    data_modality: ['molecules', 'tabular'],
    tooling: ['rdkit', 'openbabel', 'scikit-learn'],
    network_policy: 'offline',
    mode: 'dockerfile',
    source_repo: 'builtin/frontend',
    source_ref: 'v1',
    environment: {
      base_image: 'python:3.11-slim',
      system_packages: ['bash', 'curl', 'jq', 'git', 'libxrender1', 'libxext6', 'openbabel'],
      python_packages: [
        'rdkit',
        'numpy',
        'pandas',
        'scikit-learn',
        'matplotlib'
      ],
      dockerfile: dockerfile([
        'FROM python:3.11-slim',
        '',
        'ENV DEBIAN_FRONTEND=noninteractive \\',
        '    PIP_NO_CACHE_DIR=1 \\',
        '    PYTHONUNBUFFERED=1',
        '',
        'WORKDIR /app',
        '',
        'RUN apt-get update && apt-get install -y --no-install-recommends \\',
        '    bash curl jq git \\',
        '    openbabel \\',
        '    libxrender1 libxext6 \\',
        '    && rm -rf /var/lib/apt/lists/*',
        '',
        'RUN pip install \\',
        '    numpy==2.1.3 \\',
        '    pandas==2.2.3 \\',
        '    scikit-learn==1.5.2 \\',
        '    matplotlib==3.9.2 \\',
        '    rdkit==2024.3.5',
        '',
        'CMD ["/bin/bash"]',
      ]),
      resources: { cpus: 4, memory_mb: 8192, storage_mb: 10240, gpus: 0 },
      timeouts: { agent_sec: 1500, verifier_sec: 900, build_sec: 1200 },
    },
  },
  {
    id: 'data-science-v1',
    name: 'Data Science',
    domain: 'data-science',
    env_version: 'v1.0.0',
    description: 'General analysis and ML baseline for structured data and notebooks-style tasks.',
    data_modality: ['tabular', 'csv', 'json'],
    tooling: ['pandas', 'numpy', 'scikit-learn', 'visualization'],
    network_policy: 'offline',
    mode: 'simple',
    source_repo: 'builtin/frontend',
    source_ref: 'v1',
    environment: {
      base_image: 'python:3.11-slim',
      system_packages: ['bash', 'curl', 'jq', 'git'],
      python_packages: [
        'pandas',
        'numpy',
        'scipy',
        'scikit-learn',
        'matplotlib',
        'seaborn',
        'pyarrow'
      ],
      resources: { cpus: 2, memory_mb: 4096, storage_mb: 10240, gpus: 0 },
      timeouts: { agent_sec: 1200, verifier_sec: 900, build_sec: 900 },
    },
  },
];

export function getEnvironmentPresetById(presetId) {
  return ENVIRONMENT_PRESET_CATALOG.find((preset) => preset.id === presetId) || null;
}
